
<div :id="content.idHTML" class="mb-2 liste-choix" :class="jel_getClassObject(content)">
  <label :for="idChoix" class="mt-1">
    {{ content.libChoix }}
  </label>
  <ValidationProvider v-slot="validationContext" name="optionChoisi" rules="required" tag="div">
    <div class="d-flex position-relative">
      <input
        :id="idChoix"
        v-model="optionChoisi"
        :name="content.inputNameChoix ? content.inputNameChoix : ''"
        type="hidden"
      />
      <div v-click-outside="onClickOutside" class="multiselect">
        <div @click="montrerListeChoix()">
          <b-input
            v-if="content.activerRecherche === 'true'"
            v-model="rechercheChoix"
            inputmode="text"
            class="barre-recherche"
            :placeholder="contenuPlaceholder"
            autocomplete="off"
          />
          <div v-else class="multiselect__tags">
            <span
              :id="'placeholder-' + idChoix"
              :class="[optionChoisi ? 'multiselect__single' : 'multiselect__placeholder']"
            >
              {{ contenu }}
            </span>
          </div>
        </div>
        <div
          v-show="afficherListeChoix && (!$isMobile() || content.utiliserModaleMobile !== 'true')"
          class="multiselect__content-wrapper"
        >
          <ul class="multiselect__content">
            <li
              v-if="listeChoix.length === 0 || listeChoixFiltrer.length === 0"
              @click="setInputValue()"
            >
              <span class="multiselect__option aucun-choix">
                {{
                  listeChoix.length === 0
                    ? content.libListeVide
                    : $i18n.tc('messageComponent.aucunResultat')
                }}
              </span>
            </li>
            <li
              v-for="(choix, index) in listeChoixFiltrer"
              v-else
              :key="index"
              class="multiselect__element"
              @click="setInputValue(choix)"
            >
              <span
                class="multiselect__option"
                :class="[
                  {
                    'multiselect__option--selected': optionChoisi === choix.value,
                  },
                ]"
              >
                {{ choix.option }}
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div
        v-if="content.activerRecherche === 'true'"
        class="position-icone"
        @click="effacerChampProfession()"
      >
        <svg-icon v-if="optionChoisi" icon-name="icone-fermer" fill="$couleur-primaire" />
        <svg-icon v-else icon-name="icone-search" fill="$couleur-primaire" />
      </div>
      <div v-else class="position-icone" @click="montrerListeChoix()">
        <svg-icon
          :id="iconeFlecheId"
          :class="{ rotation180: afficherListeChoix }"
          icon-name="fleche-bas"
        />
      </div>
      <b-modal
        v-if="isAffichageModale"
        id="situation"
        v-model="afficherModale"
        size="mobile"
        hide-footer
        body-class="px-0 pt-0 p-sm-2 pb-sm-7 pb-4"
        content-class="p-sm-2"
      >
        <div slot="modal-header" class="modale-header division-colonne">
          <div class="division-ligne">
            <div class="col-3 px-0">
              <button class="modale-btn-annuler text-left" block @click="fermerModale">
                {{ $t('annuler') }}
              </button>
            </div>
            <div class="col-7 text-center pr-4">
              <label class="entete pl-1">{{ content.libChoix }}</label>
            </div>
            <div class="col-2 text-right px-0">
              <button
                class="modale-btn-confirmer px-0"
                block
                :class="{ 'opacity-50': !choixModale }"
                :disabled="!choixModale"
                @click="soumettreModale()"
              >
                {{ $t('ok') }}
              </button>
            </div>
          </div>
          <!-- Section recherche -->
          <div v-if="content.activerRecherche === 'true'" class="division-ligne has-float-label">
            <b-input
              v-model="rechercheChoixMobile"
              inputmode="text"
              class="barre-recherche barre-recherche-mobile"
              :placeholder="content.placeholderSelection"
              autocomplete="off"
            />
            <label :for="content.libProfession">{{ content.placeholderSelection }}</label>
            <svg-icon
              class="icone-recherche-mobile"
              icon-name="icone-search"
              color="$couleur-primaire"
            />
          </div>
        </div>
        <div class="border-top border-bottom">
          <div class="list-group px-2">
            <button
              v-if="listeChoix.length === 0 || listeChoixFiltrer.length === 0"
              class="item-liste item-liste-non-selectionnable"
              @click="setInputValue()"
            >
              {{
                listeChoix.length === 0
                  ? content.libListeVide
                  : $i18n.tc('messageComponent.aucunResultat')
              }}
            </button>
            <button
              v-for="(choix, index) in listeChoixFiltrer"
              v-else
              :key="index"
              squared
              class="item-liste item-liste-selectionnable"
              :class="{
                'selected-list-element': choixModale
                  ? choixModale === choix
                  : choix.value == optionChoisi,
              }"
              @click="choixModale = choix"
            >
              {{ choix.option }}
            </button>
          </div>
        </div>
      </b-modal>
    </div>
    <ErreurValidation
      id="option-live-feedback"
      :message="validationContext.errors[0]"
    ></ErreurValidation>
  </ValidationProvider>
</div>
